export default {"src":"/_next/static/media/plus.4e674e59.svg","height":25,"width":25};